<button type="button" *ngFor="let step of steps; let i = index"
	class="copo-stepper-step"
	[ngClass]="'copo-stepper-label-' + step.status"
	[disabled]="step.status === 'disabled' || step.status === 'current'"
	(click)="onStepClicked(i, step)"
	mat-ripple
	matRippleColor="#00000008"
	[matRippleDisabled]="step.status === 'disabled' || step.status === 'current'">
	<div class="copo-stepper-step-mark-container"
		mat-ripple
		[matRippleDisabled]="step.status === 'disabled' || step.status === 'current'">
		{{ i + 1 }}
	</div>
	<div class="copo-stepper-step-label-container">{{ step.label }}</div>
</button>
